import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../../css/newOrder.css'

import { connect } from 'react-redux';
import * as actions from '../../actions/newOrder';
import { erpApi } from '../../services/erpApi';
import { searchProdutoForWhatsApp, findClienteByEmailOrCpf, updateClienteCpf } from '../../actions/newOrder';
import { formatCPF, formatMoney } from '../../actions';
import useDebounce from '../../utils/useDebounce';
import parseWhatsAppOrder, {
  validateParsedOrder,
  BAIRROS_RJ,
  isClienteNomeValidForSimpleId,
  normalizeNomeForSimpleId,
} from '../../utils/parseWhatsAppOrder';
import { buildCartItemsFromAbandonedItens } from '../../utils/abandonedCartNewOrder';

import Voltar from '../../components/Links/Voltar';
import SearchClient from '../../components/Search/Client';
import SearchProducts from '../../components/Search/Products';
import { Controller, useForm } from 'react-hook-form';
import Input from '../../components/Form/Input';
import TextArea from '../../components/Form/TextArea';
import { FaInfo, FaEdit } from 'react-icons/fa'

import DatePicker, { registerLocale }  from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import br from 'date-fns/locale/pt-BR';
import SearchUpsells from '../../components/Search/Upsells';

const MSG_NOME_CLIENTE_INVALIDO = 'O nome do cliente precisa ter pelo menos 3 letras sem acentos ou símbolos (apenas A–Z), com sobrenome ou nome composto quando necessário.';

const msgWhatsAppValidacaoNome = () =>
  `Erro de validação do nome — ${MSG_NOME_CLIENTE_INVALIDO}`;

const parseMoneyField = (raw) => {
  if (raw == null || raw === '') return 0;
  const s = String(raw).trim().replace(/\s/g, '');
  const normalized = s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s;
  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : 0;
};

const NewOrder = ({ history, usuario, clientes, cliente, produtos, upsells, getClientesPesquisa, getProdutosPesquisa, getUpsellsPesquisa, newOrderManual, createNewCliente }) => {

  registerLocale('br', br)

  const [clientSelection] = useState(true);
  const [getClient, setGetClient] = useState(false);
  const [newClient, setNewClient] = useState(false);
  const [whatsAppPaste, setWhatsAppPaste] = useState(false);
  const [whatsAppText, setWhatsAppText] = useState('');
  const [parseError, setParseError] = useState(null);
  const [processingWhatsApp, setProcessingWhatsApp] = useState(false);
  const [pendingCartItems, setPendingCartItems] = useState([]);

  const searchProductsRef = useRef(null);

  const { control, register, handleSubmit, formState: { errors }, setValue, watch } = useForm();
  const [cart, setCart] = useState({ items: [], total: 0 });
  const [cartUpsell, setCartUpsell] = useState({ items: [], total: 0 });
  const [errorsGeneral, setErrorsGeneral] = useState(false);
  const [clienteNomeError, setClienteNomeError] = useState(null);
  const [client, setClient] = useState({})
  const [accessSection, setAccessSection] = useState(1)
  const [documentExist, setDocumentExist] = useState(false);
  const [responseSuccess, setResponseSuccess] = useState({});

  const [form, setForm] = useState({ cpf: null });
  const [funcionarios, setFuncionarios] = useState([]);
  const [loadingFuncionarios, setLoadingFuncionarios] = useState(false);
  const [orderSubmitting, setOrderSubmitting] = useState(false);
  const orderSubmitInFlight = useRef(false);
  const abandonedPrefillDone = useRef(false);

  const orderSubtotal = Number((cart?.total || 0) + (cartUpsell?.total || 0));
  const deliveryWatch = watch('deliveryValue');
  const discountWatch = watch('orderDiscount');
  const deliveryNumPreview = parseMoneyField(deliveryWatch);
  const discountNumPreview = Math.max(0, parseMoneyField(discountWatch));
  const totalLiquidoPreview = Math.max(0, orderSubtotal + deliveryNumPreview - discountNumPreview);

  useEffect(() => {
    if (accessSection === 2) {
      setLoadingFuncionarios(true);
      erpApi.getFuncionarios()
        .then(res => {
          if (res.success) setFuncionarios(res.data || []);
          setLoadingFuncionarios(false);
        })
        .catch(() => setLoadingFuncionarios(false));
    }
  }, [accessSection]);

  const searchClient = (search) => {
    getClientesPesquisa(search, usuario.loja);
  }

  const searchProducts = (search) => {
    getProdutosPesquisa(search, usuario.loja);
  }

  const searchUpsells = (search) => {
    getUpsellsPesquisa(search, usuario.loja);
  }

  const timerFn = (callback) => {
    let timer;
    clearTimeout(timer);

    timer = setTimeout(() => {
      callback()
    }, 5000)

    return
  }

  useEffect(() => {
    const abandoned = history.location?.state?.fromAbandonedCart;
    if (!abandoned || !usuario?.loja || abandonedPrefillDone.current) return;
    abandonedPrefillDone.current = true;
    history.replace({ pathname: history.location.pathname, state: {} });

    setValue(
      'observation',
      `Pedido a partir de carrinho abandonado (${abandoned.email || 'sem e-mail'}).`
    );

    const goToOrderStep = (cartItems, clientObj) => {
      setClient(clientObj);
      setPendingCartItems(cartItems);
      setAccessSection(2);
    };

    const run = async () => {
      const cartItems = await buildCartItemsFromAbandonedItens(abandoned.itens, usuario.loja);
      if (!cartItems.length) {
        setErrorsGeneral('Não foi possível carregar os produtos deste carrinho abandonado.');
        timerFn(() => setErrorsGeneral(false));
      }

      const existingCliente = await findClienteByEmailOrCpf(abandoned.email, abandoned.cpf, usuario.loja);
      if (existingCliente) {
        const nomeAbandonadoOk = isClienteNomeValidForSimpleId(abandoned.nome);
        const nomeCadastroOk = isClienteNomeValidForSimpleId(existingCliente.nome);
        if (!nomeCadastroOk && !nomeAbandonadoOk) {
          setGetClient(true);
          setErrorsGeneral(MSG_NOME_CLIENTE_INVALIDO);
          timerFn(() => setErrorsGeneral(false));
          if (cartItems.length) setPendingCartItems(cartItems);
          return;
        }
        let clientObj = existingCliente;
        if (!nomeCadastroOk && nomeAbandonadoOk) {
          clientObj = { ...existingCliente, nome: normalizeNomeForSimpleId(abandoned.nome) };
        }
        const hasCpfPasted = (abandoned.cpf || '').replace(/\D/g, '').length >= 11;
        const clientoSemCpf = !clientObj.cpf || String(clientObj.cpf).replace(/\D/g, '').length < 11;
        if (hasCpfPasted && clientoSemCpf) {
          clientObj = await updateClienteCpf(clientObj, abandoned.cpf, usuario.loja);
        }
        goToOrderStep(cartItems, clientObj);
        return;
      }

      if (isClienteNomeValidForSimpleId(abandoned.nome)) {
        createNewCliente(
          {
            clientName: abandoned.nome,
            clientEmail: abandoned.email || '',
            clientCpf: abandoned.cpf || '',
            clientPhone: abandoned.telefone || '',
          },
          usuario.loja,
          (error, success) => {
            if (error) {
              setNewClient(true);
              setValue('clientName', abandoned.nome || '');
              setValue('clientEmail', abandoned.email || '');
              setValue('clientCpf', abandoned.cpf || '');
              setValue('clientPhone', abandoned.telefone || '');
              if (cartItems.length) setPendingCartItems(cartItems);
              return;
            }
            goToOrderStep(cartItems, success.cliente);
          }
        );
        return;
      }

      setNewClient(true);
      setValue('clientName', abandoned.nome || '');
      setValue('clientEmail', abandoned.email || '');
      setValue('clientCpf', abandoned.cpf || '');
      setValue('clientPhone', abandoned.telefone || '');
      if (cartItems.length) setPendingCartItems(cartItems);
    };

    run();
  }, [history, usuario, createNewCliente, setValue]);

  const notifyInvalidNomeCliente = () => {
    setClienteNomeError(MSG_NOME_CLIENTE_INVALIDO);
    timerFn(() => setClienteNomeError(null));
  };

  const goSuccess = (response) => {
    setAccessSection(3)
    setResponseSuccess(response)
  }

  const handleAdd = (data) => {
    if (newClient && !isClienteNomeValidForSimpleId(data.clientName)) {
      notifyInvalidNomeCliente();
      return;
    }

    newClient && createNewCliente(data, usuario.loja, (error, success) => {
      console.log(error)
      if(error) {
        setDocumentExist('Este CPF já está sendo utilizado!');
        timerFn(() => setDocumentExist(false))
        return
      } else {
      setDocumentExist(false)
        setNewClient(false)
        setClient(success.cliente)
        setClienteNomeError(null)
        setAccessSection(2)
      }
    })

    if(!client || newClient){
      setErrorsGeneral("Por favor, informe os dados do cliente.")
      timerFn(() => setErrorsGeneral(false))
      return
    } else setErrorsGeneral(false);

    if (!isClienteNomeValidForSimpleId(client.nome)) {
      setErrorsGeneral(MSG_NOME_CLIENTE_INVALIDO)
      timerFn(() => setErrorsGeneral(false))
      return
    }

    const cartItems = cart?.items || [];
    if (!cartItems.length) {
      setErrorsGeneral("Por favor, adicione ao menos um produto.")
      timerFn(() => setErrorsGeneral(false))
      return
    } else setErrorsGeneral(false);

    if(!data.deliveryValue || data.deliveryValue === ''){
      setErrorsGeneral("Por favor, informe o valor de entrega.")
      timerFn(() => setErrorsGeneral(false))
      return
    } else setErrorsGeneral(false);

    const goodsTotal = Number((cart?.total || 0) + (cartUpsell?.total || 0));
    const deliveryNum = parseMoneyField(data.deliveryValue);
    const discountNum = Math.max(0, parseMoneyField(data.orderDiscount));
    if (discountNum > goodsTotal + deliveryNum) {
      setErrorsGeneral("O desconto não pode ser maior que o valor do pedido mais a entrega.")
      timerFn(() => setErrorsGeneral(false))
      return
    }

    if (orderSubmitInFlight.current) return;
    orderSubmitInFlight.current = true;
    setOrderSubmitting(true);

    newOrderManual({ form: data, client, cart, cartUpsell }, (result) => {
      orderSubmitInFlight.current = false;
      setOrderSubmitting(false);
      if (result?.status && result.status >= 400) {
        setErrorsGeneral(result.message || 'Não foi possível criar o pedido.');
        timerFn(() => setErrorsGeneral(false));
        return;
      }
      goSuccess(result);
    });
  }

  const debounceSubmit = useDebounce(handleAdd, 500);

  const cartCallback = (newCart) => {
    const _reduceCart = (newCart || []).reduce((prev, current) => {
      return prev + +(current.price*current.quantity)
    }, 0)
    setCart({ items: newCart, total: _reduceCart });
  }

  const cartCallbackUpsell = (newCart) => {
    const _reduceCart = (newCart || []).reduce((prev, current) => {
      return prev + +(current.price*current.quantity)
    }, 0)
    setCartUpsell({ items: newCart, total: _reduceCart });
  }

  const processWhatsAppText = async () => {
    setParseError(null);
    setProcessingWhatsApp(true);

    const parsed = parseWhatsAppOrder(whatsAppText);
    const { valid, missing } = validateParsedOrder(parsed);

    if (!valid) {
      setParseError(`Campos faltando: ${missing.join(', ')}`);
      setProcessingWhatsApp(false);
      return;
    }

    const cartItems = [];
    for (const item of parsed.products) {
      const found = await searchProdutoForWhatsApp(item.name, usuario.loja);
      if (found.length > 0) {
        const product = found[0];
        const price = item.price != null ? item.price : (product.preco ?? product.price);
        cartItems.push({
          _id: product._id,
          title: product.titulo || product.title,
          price,
          picture: product.fotos?.[0] ?? product.picture,
          quantity: 1
        });
      }
    }
    setPendingCartItems(cartItems);

    setValue('deliveryStreet', parsed.deliveryStreet);
    setValue('deliveryNumber', parsed.deliveryNumber);
    if (parsed.deliveryNeighbor) setValue('deliveryNeighbor', parsed.deliveryNeighbor);
    setValue('deliveryComplement', parsed.deliveryComplement);
    setValue('deliveryDate', parsed.deliveryDate);
    setValue('deliveryPeriod', parsed.deliveryPeriod || 'Noite 18h às 21h');
    setValue('senderShipping', parsed.quemEnvia);
    setValue('senderReciever', parsed.quemRecebe);
    setValue('messageCard', parsed.mensagem);
    setValue('deliveryValue', parsed.deliveryValue != null ? String(parsed.deliveryValue) : '');
    setValue('observation', parsed.observation || '');

    const closeWhatsAppPasteUi = () => {
      setWhatsAppPaste(false);
      setWhatsAppText('');
    };

    const hasClientData = parsed.clientName && (parsed.clientEmail || parsed.clientCpf);
    if (hasClientData) {
      const existingCliente = await findClienteByEmailOrCpf(parsed.clientEmail, parsed.clientCpf, usuario.loja);
      if (existingCliente) {
        const nomeColadoOk = isClienteNomeValidForSimpleId(parsed.clientName);
        const nomeCadastroOk = isClienteNomeValidForSimpleId(existingCliente.nome);
        if (!nomeCadastroOk && !nomeColadoOk) {
          setParseError(msgWhatsAppValidacaoNome());
          setProcessingWhatsApp(false);
          return;
        }
        const clienteComNomeParaPedido =
          !nomeCadastroOk && nomeColadoOk
            ? { ...existingCliente, nome: normalizeNomeForSimpleId(parsed.clientName) }
            : existingCliente;
        const hasCpfPasted = (parsed.clientCpf || '').replace(/\D/g, '').length >= 11;
        const clientoSemCpf = !clienteComNomeParaPedido.cpf || String(clienteComNomeParaPedido.cpf).replace(/\D/g, '').length < 11;
        if (hasCpfPasted && clientoSemCpf) {
          const updated = await updateClienteCpf(clienteComNomeParaPedido, parsed.clientCpf, usuario.loja);
          setClient(typeof updated === 'object' ? updated : clienteComNomeParaPedido);
        } else {
          setClient(clienteComNomeParaPedido);
        }
        closeWhatsAppPasteUi();
        setAccessSection(2);
        setProcessingWhatsApp(false);
      } else {
        if (!isClienteNomeValidForSimpleId(parsed.clientName)) {
          setParseError(msgWhatsAppValidacaoNome());
          setProcessingWhatsApp(false);
          return;
        }
        createNewCliente(
          {
            clientName: parsed.clientName,
            clientEmail: parsed.clientEmail || '',
            clientCpf: parsed.clientCpf || '',
            clientPhone: parsed.clientPhone || ''
          },
          usuario.loja,
          (error, success) => {
            setProcessingWhatsApp(false);
            if (error) {
              setParseError('Erro ao cadastrar cliente. Selecione ou cadastre manualmente.');
              setWhatsAppPaste(true);
            } else {
              if (!isClienteNomeValidForSimpleId(success.cliente.nome)) {
                setParseError(msgWhatsAppValidacaoNome());
                setWhatsAppPaste(true);
                return;
              }
              closeWhatsAppPasteUi();
              setClient(success.cliente);
              setDocumentExist(false);
              setAccessSection(2);
            }
          }
        );
      }
    } else {
      closeWhatsAppPasteUi();
      setGetClient(true);
      setNewClient(false);
      setProcessingWhatsApp(false);
    }
  };

  return (
    <div className="newOrder container-centered">
      <div className="head">
        <Voltar history={history} />
      </div>
      <div className="content">
          { accessSection < 3 ? (
            <>
              <h1>Criar novo pedido</h1>

              <form className="form" onSubmit={handleSubmit(debounceSubmit)}>
                <div className="sectionClient">

                  { (!newClient && !getClient && !whatsAppPaste) && accessSection === 1 && clientSelection && (
                    <div className="clientSelection">
                      <button onClick={() => setGetClient(true)}>Selecionar cliente existente</button>
                      <button onClick={() => setNewClient(true)}>Adicionar novo cliente</button>
                      <button type="button" onClick={() => { setParseError(null); setWhatsAppPaste(true); }}>Colar do WhatsApp</button>
                      {/*<button type="button">Colar do WhatsApp</button>*/}
                    </div>
                  )}

                  { accessSection === 1 && whatsAppPaste && (
                    <div className="newClient whatsAppPaste">
                      <h2>Colar pedido do WhatsApp</h2>
                      <p className="whatsAppHint">Cole o texto da conversa do WhatsApp. O sistema irá extrair os dados automaticamente.</p>
                      <div className="TextArea">
                        <textarea
                          rows={14}
                          name="whatsAppText"
                          placeholder={`DATA: 11/03
PERIODO: Noite
CONTATO: 11 99998-4707 - Erick

PRODUTO: Buque com 12 rosas 279,00
ENVIO: 25,00
TOTAL: 304,00

ENDEREÇO: av exemplo 123 Bairro - complemento
QUEM ENVIA: Nome
QUEM RECEBE: Nome
MENSAGEM: ...`}
                          value={whatsAppText}
                          onChange={(e) => setWhatsAppText(e.target.value)}
                        />
                      </div>
                      { parseError && (
                        <div className="errors whatsAppParseError" style={{ marginTop: 12 }} role="alert">
                          <span><FaInfo /> {parseError}</span>
                        </div>
                      ) }
                      <div className="ButtonSubmit" style={{ marginTop: 16, flexDirection: 'row', gap: 12 }}>
                        <button type="button" onClick={processWhatsAppText} disabled={processingWhatsApp || !whatsAppText.trim()}>
                          { processingWhatsApp ? 'Processando...' : 'Processar e preencher' }
                        </button>
                        <button type="button" onClick={() => { setWhatsAppPaste(false); setParseError(null); setWhatsAppText(''); }} className="secondary">
                          Voltar
                        </button>
                      </div>
                    </div>
                  )}

                  { accessSection === 1 && newClient && (
                    <div className="newClient">
                      <h2>Adicionando novo cliente</h2>
                      <div className="item">
                        <div className="double">
                          <Input type="text" errors={errors} register={{...register('clientName', { required: true })}} name="clientName" placeholder="Nome Completo" />
                          <Input type="text" errors={errors} register={{...register('clientCpf')}} value={form.cpf} name="clientCpf" placeholder="CPF" onChange={(e) => setForm({ ...form, cpf: formatCPF(e.target.value) }) } />
                        </div>
                        <div className="double">
                          <Input type="text" errors={errors} register={{...register('clientEmail')}} name="clientEmail" placeholder="E-mail" />
                          <Input type="text" errors={errors} register={{...register('clientPhone')}} name="clientPhone" placeholder="Telefone" />
                        </div>
                        <div className="ButtonSubmit">
                          { documentExist ? (
                            <div className="errors">
                              <span><FaInfo /> {documentExist}</span>
                            </div>
                          ) : '' }
                          { clienteNomeError ? (
                            <div className="errors">
                              <span><FaInfo /> {clienteNomeError}</span>
                            </div>
                          ) : '' }
                          <button>Adicionar Cliente</button>
                        </div>
                      </div>
                      <span className="added">Cliente já existe? <button onClick={() => { setNewClient(false); setGetClient(true) }}>Voltar para a Busca</button></span>
                    </div>
                  )}
                    
                  { accessSection === 1 && getClient && (
                    <div className="newClient">
                      <h2>Selecionar cliente existente</h2>
                      <SearchClient
                        data={clientes?.docs || []}
                        searchAction={(search) => searchClient(search)}
                        callback={(clientProps) => setClient(clientProps)}
                        accessAction={() => { setClienteNomeError(null); setAccessSection(2); }}
                        canAccessWithClient={(c) => {
                          if (!isClienteNomeValidForSimpleId(c.nome)) {
                            notifyInvalidNomeCliente();
                            return false;
                          }
                          return true;
                        }}
                      />
                      { clienteNomeError ? (
                        <div className="errors" style={{ marginTop: 12 }}>
                          <span><FaInfo /> {clienteNomeError}</span>
                        </div>
                      ) : null }
                      <span className="added">Não encontrou o cliente? <button onClick={() => { setNewClient(true); setGetClient(false) }}>Clique aqui para adicionar um novo</button></span>
                    </div>
                  ) }
                  
                  { accessSection === 2 && (
                    <div className="clientConnected">
                      <h2>Cliente</h2>
                      <h4 onClick={() => { setClient({}); setAccessSection(1); setNewClient(false); setGetClient(true); setWhatsAppPaste(false) }}>{client.nome} <FaEdit /></h4>
                    </div>
                  ) }
              </div>
    
              { accessSection === 2 ? (
                <div className="stepTwo">
                  <SearchProducts ref={searchProductsRef} data={produtos} cartCallback={(newCart) => cartCallback(newCart)} searchAction={(search) => searchProducts(search)} initialItems={pendingCartItems} onInitialItemsApplied={() => setPendingCartItems([])} />
    
                  <SearchUpsells data={upsells} cartCallback={(newCart) => cartCallbackUpsell(newCart)} searchAction={(search) => searchUpsells(search)} />

                  <div className="formSection">
                    <h2>Dados de entrega</h2>
                    <div className="streetAndNumber">
                      <Input type="text" errors={errors} register={{...register('deliveryStreet', { required: true })}} name="deliveryStreet" placeholder="Endereço" />
                      <Input type="text" errors={errors} register={{...register('deliveryNumber', { required: true })}} name="deliveryNumber" placeholder="Número" />
                    </div>
                    <div className="double">
                      <div className="Input Select">
                        <select {...register('deliveryNeighbor', { required: true })}>
                          <option value="">Selecione o bairro</option>
                          {BAIRROS_RJ.map((b) => (
                            <option key={b} value={b}>{b}</option>
                          ))}
                        </select>
                        {errors.deliveryNeighbor && errors.deliveryNeighbor.type === 'required' && <span className="danger">Obrigatório *</span>}
                      </div>
                      <Input type="text" errors={errors} register={{...register('deliveryComplement')}} name="deliveryComplement" placeholder="Complemento" />
                    </div>
                    <div className="double">
                      <div className="Input inputDate">
                        <Controller
                          control={control}
                          name='deliveryDate'
                          render={({ field }) => (
                            <DatePicker locale="br" dateFormat="dd/MM/yyyy"
                              placeholderText='Data da Entrega'
                              onChange={(date) => field.onChange(date)}
                              selected={field.value}
                            />
                        )} />
                      </div>
    
                      <div className="Input Select">
                        <select {...register("deliveryPeriod")}>
                          <option value="Manhã 9h às 12h">Manhã 9h às 12h</option>
                          <option value="Tarde 12h às 18h">Tarde 12h às 18h</option>
                          <option value="Noite 18h às 21h">Noite 18h às 21h</option>
                        </select>
                      </div>
                    </div>
                  </div>
    
                  <div className="formSection">
                    <h2>Dados do Cartão</h2>
                    <div className="double">
                      <Input type="text" errors={errors} register={{...register('senderShipping', { required: true })}} name="senderShipping" placeholder="Quem Envia" />
                      <Input type="text" errors={errors} register={{...register('senderReciever', { required: true })}} name="senderReciever" placeholder="Quem Recebe" />
                    </div>
                    <TextArea rows="4" errors={errors} register={{...register('messageCard')}} name="messageCard" placeholder="Mensagem no cartão" maxLength="1600" />
                  </div>
    
                  { orderSubtotal > 0 && (
                    <div className="formSection flex-end align-right">
                      <h2>Detalhes</h2>
                      <div className="details">
                        <div className="item">
                          <h4>Valor do Pedido</h4>
                          <span>{formatMoney(orderSubtotal)}</span>
                        </div>
                        <div className="item">
                          <h4>Valor da Entrega</h4>
                          <div className="inputValue">
                            <span>R$</span>
                            <Input type="text" errors={errors} register={{...register('deliveryValue')}} name="deliveryValue" placeholder="Valor" />
                            <span>,00</span>
                          </div>
                        </div>
                        <div className="item">
                          <h4>Desconto (opcional)</h4>
                          <div className="inputValue">
                            <span>R$</span>
                            <Input type="text" errors={errors} register={{...register('orderDiscount')}} name="orderDiscount" placeholder="0" />
                            <span>,00</span>
                          </div>
                        </div>
                        { discountNumPreview > 0 && (
                          <div className="item">
                            <h4>Desconto aplicado</h4>
                            <span>- {formatMoney(discountNumPreview)}</span>
                          </div>
                        ) }
                        <div className="item">
                          <h4>Total</h4>
                          <span>{formatMoney(totalLiquidoPreview)}</span>
                        </div>
                      </div>
                    </div>
                  ) }
    
                  <div className="formSection">
                    <h2>Observação</h2>
                    <TextArea rows="4" errors={errors} register={{...register('observation')}} name="observation" placeholder="Alguma mensagem?" />
                  </div>
    
                  <div className="formSection">
                    <h2>Vendedor(a) (Opcional)</h2>
                    <div className="Input Select">
                      <select {...register('vendedorId')} disabled={loadingFuncionarios}>
                        <option value="">Selecione o vendedor</option>
                        {funcionarios.map(f => (
                          <option key={f.id} value={f.id}>{f.nome}</option>
                        ))}
                      </select>
                    </div>
                  </div>
    
                  <div className="ButtonSubmit">
                    { errorsGeneral ? (
                      <div className="errors">
                        <span><FaInfo /> {errorsGeneral}</span>
                      </div>
                    ) : '' }
                    <button type="submit" disabled={orderSubmitting}>
                      {orderSubmitting ? 'Enviando…' : 'Finalizar Pedido'}
                    </button>
                  </div>
                </div>
                ) : '' }
              
              </form>
            </>
          ) : (
            <div className="success">
              <h1>Tudo certo!</h1>
              <p>Pedido criado com sucesso, clique no botão abaixo para ver mais :D</p>
              { (responseSuccess?.avisosValidacao || []).length > 0 && (
                <div className="errors" style={{ marginTop: 16, marginBottom: 16 }} role="status">
                  { responseSuccess.avisosValidacao.map((aviso, idx) => (
                    <span key={idx}><FaInfo /> Atenção: {aviso} O pedido foi registrado mesmo assim.</span>
                  )) }
                </div>
              ) }
              <div className="action">
                <Link to={`/`}>Ver Pedidos</Link>
              </div>
            </div>
          )}

      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
	usuario: state.auth.usuario,
	clientes: state.cliente.clientes,
	cliente: state.cliente.cliente,
	produtos: state.produto.produtos,
  upsells: state.upsell.upsells
});

export default connect(mapStateToProps, actions)(NewOrder);